import React from 'react'
import "./Header.scss"

function Header() {
  return (
    <div className='header'><h1>AnyMail Verifier</h1></div>
  )
}

export default Header